/**
 * Contract Manager API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse} from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {LoaContactLoaContactread} from '../model/loaContactLoaContactread';
import {LoaContactLoaContactwrite} from '../model/loaContactLoaContactwrite';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class LoaContactService {

  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  protected basePath = 'https://localhost';

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * Removes the LoaContact resource.
   *
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteLoaContactItem(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;

  public deleteLoaContactItem(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;

  public deleteLoaContactItem(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;

  public deleteLoaContactItem(id: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteLoaContactItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.delete<any>(`${this.basePath}/api/loa-contacts/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves the collection of LoaContact resources.
   *
   * @param companyUniqid
   * @param companyUniqid2
   * @param email
   * @param email2
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getLoaContactCollection(companyUniqid?: string, companyUniqid2?: Array<string>, email?: string, email2?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<LoaContactLoaContactread>>;

  public getLoaContactCollection(companyUniqid?: string, companyUniqid2?: Array<string>, email?: string, email2?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<LoaContactLoaContactread>>>;

  public getLoaContactCollection(companyUniqid?: string, companyUniqid2?: Array<string>, email?: string, email2?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<LoaContactLoaContactread>>>;

  public getLoaContactCollection(companyUniqid?: string, companyUniqid2?: Array<string>, email?: string, email2?: Array<string>, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (companyUniqid !== undefined) {
      queryParameters = queryParameters.set('company.uniqid', <any>companyUniqid);
    }
    if (companyUniqid2) {
      companyUniqid2.forEach((element) => {
        queryParameters = queryParameters.append('company.uniqid[]', <any>element);
      });
    }
    if (email !== undefined) {
      queryParameters = queryParameters.set('email', <any>email);
    }
    if (email2) {
      email2.forEach((element) => {
        queryParameters = queryParameters.append('email[]', <any>element);
      });
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<Array<LoaContactLoaContactread>>(`${this.basePath}/api/loa-contacts`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves a LoaContact resource.
   *
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCoreLoaContactItem(id: string, observe?: 'body', reportProgress?: boolean): Observable<LoaContactLoaContactread>;

  public getCoreLoaContactItem(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LoaContactLoaContactread>>;

  public getCoreLoaContactItem(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LoaContactLoaContactread>>;

  public getCoreLoaContactItem(id: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getLoaContactItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<LoaContactLoaContactread>(`${this.basePath}/api/loa_contacts/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Creates a LoaContact resource.
   *
   * @param loaContact The new LoaContact resource
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public postLoaContactCollection(loaContact?: LoaContactLoaContactwrite, observe?: 'body', reportProgress?: boolean): Observable<LoaContactLoaContactread>;

  public postLoaContactCollection(loaContact?: LoaContactLoaContactwrite, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LoaContactLoaContactread>>;

  public postLoaContactCollection(loaContact?: LoaContactLoaContactwrite, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LoaContactLoaContactread>>;

  public postLoaContactCollection(loaContact?: LoaContactLoaContactwrite, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
      'application/json'
    ];
    let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<LoaContactLoaContactread>(`${this.basePath}/api/loa-contacts`,
      loaContact,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (let consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

}
